// Integración de los avances de main (ver .claude/plans/tech-debt): color de las cápsulas de
// link externo, ida y vuelta entre `rgb(...)` (lo que el navegador refleja en `style.color`) y
// `#hex` (lo que se guarda/edita en el dropdown de LilMenu). Usado por
// `useEditorEventDelegation`/`useSelectionPopup`/`useDoctexToolbarActions` (todos extraídos de
// `DoctexHtml.jsx`, 02.6-docs.md §5).
export const rgbToHex = (rgb) => {
    if (!rgb || !rgb.startsWith('rgb')) return rgb;
    const values = rgb.match(/\d+/g);
    if (!values || values.length < 3) return rgb;
    const [r, g, b] = values;
    return `#${Number(r).toString(16).padStart(2, '0')}${Number(g).toString(16).padStart(2, '0')}${Number(b).toString(16).padStart(2, '0')}`.toUpperCase();
};

export const hexToRgbStr = (hex) => {
    if (!hex) return '76, 175, 80';
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : '76, 175, 80';
};
